import React, { useEffect, useRef } from "react"

import { FlowQuestionData, FlowQuestionId } from "types"
import * as styles from "./styles.module.scss"
import SummaryAccordionItem from "../SummaryAccordionItem"

export interface SummaryAccordionProps {
  editHandler: (questionId: FlowQuestionId) => void
  isOpen: boolean
  questionsData: FlowQuestionData
  userAnswers: any
}

const SummaryAccordion: React.FC<SummaryAccordionProps> = ({
  editHandler,
  isOpen,
  userAnswers,
  questionsData,
}) => {
  console.log

  const mask = useRef<HTMLDivElement>(null)
  const list = useRef<HTMLUListElement>(null)

  const setMaskMaxHeight = () => {
    let maskMaxHeight = "initial"

    if (!list.current || !mask.current) return

    if (isOpen) {
      const listScrollHeight = list.current.scrollHeight

      if (listScrollHeight) {
        maskMaxHeight = listScrollHeight + "px"
      }
    } else {
      maskMaxHeight = "4px"
    }

    mask.current.style.maxHeight = maskMaxHeight
  }

  useEffect(() => {
    setMaskMaxHeight()
  }, [isOpen])

  return (
    <div className={styles.accordion}>
      <div className={styles.pagePadding}>
        <div
          className={styles.mask}
          data-js-flow-summary-accordion={isOpen ? "open" : "close"}
          ref={mask}
        >
          <ul className={styles.list} ref={list}>
            {questionsData &&
              Object.keys(questionsData).map((questionId) => (
                <SummaryAccordionItem
                  editHandler={editHandler}
                  key={questionId}
                  questionId={questionId}
                  questionsData={questionsData}
                  userAnswers={userAnswers}
                />
              ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default SummaryAccordion
